module.exports = __webpack_public_path__ + "img/img3.0e591292.jpg";